<template>

  <div class="uk-child-width-1-1" uk-grid>
    <div class="uk-padding">
      <div class="uk-container">
        <h1 class="uk-heading-line uk-text-center specHeading">Student Tertiary Experience Programme (STEP)</h1>
        <div class="uk-child-width-1-2@m" uk-grid>
          <div>
            <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px;  color:rgb(197,179,88)"><span>What are the Objectives?</span></h1>
            <p>The main objectives of STEP are:</p>
            <ul class="uk-list ">
              <li>1.	To have 100% of first year students assigned to a STEP Volunteer and get assistance to transition
                smoothly into university life</li>
              <li>2.	To train approximately 200 second to final year students across all disciplines to serve as STEP
                Volunteers for student success</li>
              <li>3.	To empower first year students to persevere in their academic pursuits and achieve greater retention rates</li>
              <li>4.	To get students more involved in academic, social, physical, and spiritual activities on campus
                and contribute to greater institutional commitment</li>
            </ul>
          </div>
          <div>
            <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px; color:rgb(197,179,88)"><span>How Will it Work?</span></h1>
            <p>First year students will be assigned a STEP Brother/ Sister, following their admission to the university,
              who will contact them regularly to provide guidance on academic pursuits, social and spiritual events,
              and general university activities designed for their personal and professional development.
              STEP Brothers/ Sisters will have the opportunity to accompany their siblings on off-campus events,
              as necessary. First year students will be assigned a STEP Brother/ Sister based on their academic
              departments and engage in group sessions with assigned STEP Brother/ Sister (s). </p>
          </div>
        </div>
      </div>
    </div>
    <div class="uk-padding uk-background-muted">
      <div class="uk-container " >
        <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px; color:rgb(3, 56, 96)"><span>Who Can Apply?</span></h1>
        <p>Second to final year students can volunteer to serve as STEP Volunteers to freshmen. Chairs/ Personnel in
          academic departments will also recommend their product samples to serve as STEP Volunteers to educate new
          students about the criteria for success in their academic departments. </p>
        <div>
          <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px; color:rgb(3, 56, 96) "><span>What are the Requirements?</span></h1>
          <p>STEP Brother/ Sister will consistently demonstrate the attributes of the NCU product sample to students,
            are knowledgeable about campus services and events, and seeks to provide sound advice and direction to
            new students to aid in their success. To participate as a STEP Brother/ Sister, interested students must
            have or will meet the following requirements:</p>
          <div class="uk-child-width-1-2@m" uk-grid>
            <div>
              <ul class="uk-list uk-list-bullet" style="font-size: 14px;">
                <li>Second to Final Year Student with minimum cumulative GPA of 3.0 and good citizenship records </li>
                <li>Mature student with a desire to use gifts and talents to share the love of Jesus with others</li>
                <li>Possess good written and oral communication skills</li>
                <li>Attendance at all training sessions, online or face-to-face, and monthly small group sessions throughout the academic year (three each semester) </li>
                <li>Good interpersonal skills coupled with the ability to resolve conflicts or solve problems</li>
              </ul>
            </div>
            <div>
              <ul class="uk-list uk-list-bullet" style="font-size: 14px;">
                <li>Service-oriented with a willingness to cater to the needs of freshmen students as they arise</li>
                <li>Strong recommendation from academic department</li>
                <li>Availability to participate in a major orientation session for Volunteers each semester, during the week before New Students Orientation </li>
                <li>Participation in Orientation, outreach activities, or tours for new students each semester</li>
                <li>Able to serve as a mentor and role model for students and staff</li>
              </ul>
            </div>
          </div>
          <p class="uk-text-justify" >
            Students interested in becoming STEP Brother/ Sister are invited to complete the online application form
            via this link: <a href="https://docs.google.com/forms/d/1bulmtuZJGoBciKD2IHRpqBMou_vtwdEIVoh08tPMyjE/edit" target="_blank"> here </a>
            or send an email to <u>engagementandretention@ncu.edu.jm</u> requesting the paper-based version for completion.
          </p>
        </div>
      </div>
    </div>

    <div class="uk-padding">
      <div class="uk-container">
        <div class="uk-child-width-1-2@m" uk-grid>
          <div>
            <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px;  color:rgb(197,179,88)"><span>What are the benefits for STEP Reps?</span></h1>
            <p>STEP Reps will get the opportunity to develop or improve on their employability skills, especially leadership
              and communication. STEP Reps will be equipped with the requisite knowledge about university resources and
              activities designed for student success. Reps will be provided with branded shirts and the required resources
              to assist new students. Reps will also have the opportunity to qualify for cash prizes and awards based on
              their achievements of the STEP objectives. Reps who serve for a year will be awarded a certificate of
              participation for inclusion in their professional portfolio. All major costs associated with STEP will
              be borne by the office of SEAR.
            </p>

          </div>
          <div>
            <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px; color:rgb(197,179,88)"><span>How will participants be remunerated?</span></h1>
            <p>STEP Reps will be paid JA$200 per hour on orientation days and for their participation at other major
              events requiring their service. The monies earned will be credited to their student account on a monthly basis. </p>
            <div style="padding-right: 50px; padding-left: 50px;">
              <img class="uk-border-circle" src="../assets/sear4.jpg" width="200" height="200" alt="Border circle">
              <img class="uk-border-circle" src="../assets/sear3.jpg" width="200" height="200" alt="Border circle">
            </div>


          </div>
        </div>
      </div>
    </div>

    <div class="uk-padding uk-background-muted">
      <div class="uk-container">
        <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px;color:rgb(3, 56, 96)"><span>How will it be Evaluated?</span></h1>

        <p>Research has indicated that students who are involved in a successful first year experience programme
          usually achieve greater academic success and contribute to higher retention rates. Three main components
          will be evaluated to determine impact on fall-to-fall retention rates:</p>

        <ul class="uk-list uk-list-bullet ">
          <li>Academic – Number of new students joining Clubs and achieving GPA of 3.0 or higher</li>
          <li>Spiritual – Number of new students joining Clubs and engaging in outreach efforts</li>
          <li>Social – Number of new students participating in Clubs and attending social activities</li>
          <li>Physical – Number of freshmen registered for sporting teams and fitness centre</li>
        </ul>
      </div>
    </div>

    <div class="uk-padding">
      <div class="uk-container">
        <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px;  color:rgb(197,179,88)"><span>Roles and Responsibilities of STEP Participants</span></h1>
        <p>The following categories of individuals will assist SEAR to motivate new students to have greater academic
          integration, physical, social and spiritual development while making the transition to Northern Caribbean University. </p>

        <table class="uk-table uk-table-middle uk-table-divider uk-table-striped ">
          <thead>
          <tr>
            <th class="uk-width-medium@s"></th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>ROLES OF STEP EXPERIENCE DESIGNER</td>
            <td>
              University workers will be STEP experience designers.
              <br><br>
              STEP experience designers will give students an unforgettable university experience that translates
              to retention and student success.
              <br><br>
              College/School personnel will impact academic outcomes; chaplaincy Services and Club will impact
              spiritual outcomes; Social Development will impact the physical and social; SEAR and Clubs will
              collaborate for the Social and academic outcomes.
            </td>
          </tr>

          <tr>
            <td>ROLES OF STEP REP</td>
            <td>
              Establish and maintain relationships of trust and confidentiality with new students to earn their confidence and the ability to impact their personal and professional development
              <br><br>
              Gain current and factual information about the offices, services, and activities of the university in order to properly inform or refer new students
              <br><br>
              Report any student special health problems and academic distress signals, personal and/ or social concerns to the office of SEAR
              <br><br>
              Serve as a liaison between freshmen and the office of SEAR; submit weekly progress report to SEAR
              <br><br>
              Participate in the Freshman Orientation program each semester and accompany students to campus or external events planned for them
              <br><br>
              Host a minimum of one (1) group session each month for new students assigned
              <br><br>
              Assist with other related duties in collaboration with the Director for SEAR

            </td>
          </tr>

          <tr>
            <td>ROLES OF STEP ADVISOR (Academic Depts. Personnel)</td>
            <td>
              Assist students to understand the educational context within which they are enrolled
              <br><br>Advise students on the selection of appropriate courses and other educational experiences
              <br><br>Provide accurate and timely information and interpret institutional, general education, and major requirements
              <br><br>Clarify academic policies and procedures
              <br><br>Reinforce student self-direction and self-sufficiency

            </td>
          </tr>

          <tr>
            <td>ROLES OF STEP COACH/ MENTOR (District Pastors/ Community Members)</td>
            <td>
              Assist students to develop personal competencies and not unhealthy dependencies on the coaching or mentoring relationship
              <br><br>Encourage students to continually improve skills and competencies and to establish new networks where necessary to achieve their goals
              <br><br>Use questioning techniques to encourage students’ own thought processes in order to identify solutions and actions rather than have them rely on others to make decisions for them
              <br><br>Support the student in setting appropriate goals and methods of assessing progress in relation to these goals
              <br><br>Participate in STEP events or assist with planning first year experience events for students
            </td>
          </tr>

          </tbody>
        </table>

      </div>
    </div>


  </div>
</template>

<script>
    export default {
        name: "step"
    }
</script>

<style scoped>

</style>
